import "./GasConditioningAndCooling.module.css";
import Header from "@/reusable_sections/Header";
import GasConditioning from "./sections/GasConditioning";
import TechnicalBenefits from "./sections/TechnicalBenefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function GasConditioningAndCoolingPage() {
  return <div>
      <Header />
      <GasConditioning />
      <TechnicalBenefits />
      <CallToAction />
      <Footer />
    </div>;
}